
(function documentAndContainerFindDefinition() {
    'use strict';
    angular.module('Entities')
        .service('documentAndContainerFindService', [
            'restUrlBuilder',
            function documentService(restUrlBuilder) {

                this.get = function get(params) {
                    return restUrlBuilder.all('documentAndContainerFind').put(params);
                };

                this.exportToXLS = function (params) {
                    return restUrlBuilder.all('documentAndContainerFind/exportxls').put(params);
                };

            }
        ]);

})();